// Утилиты для работы с ключевыми словами карт.
// Список keywords хранится в card.keywords (массив строк) на инстансе Card.
// Архитектурно ключевые слова могут добавляться/убираться во время матча
// (например, аура, дающая taunt) — но в А.4.1 этого ещё нет.

export const KW = Object.freeze({
  TAUNT:   'taunt',
  STEALTH: 'stealth',
  PIERCE:  'pierce',
  RUSH:    'rush',        // А.4.4.3: для Инфильтратора (поведение через trigger, не через keyword)
  FRENZY:  'frenzy',      // Б.2.a: Неистовство — юнит атакует дважды за Ф3 (через Мод «Перегруз рецепторов»)
  // C.1: CHAIN_OF_COMMAND удалён, заменяется на REINFORCEMENT (фракционная аура Глобала).
  SUPPRESSION: 'suppression',  // C.1: Глобал — Подавление вражеской зеркальной ячейки
  INFECTED: 'infected',        // C.1: Лив Лайф — Заражён (стак до 3, DoT в начале хода)
  IMMUNE:  'immune',       // В.2.d-1: Иммунитет — поглощает весь урон одного события и снимается
  POSTHUMOUS_CONTRACT: 'deathrattle_contract'  // В.2.d-3: Посмертный контракт — после смерти юнит воскрешается на свободной ячейке (одноразово). Имя в xlsx — deathrattle_contract.
});

const KNOWN = new Set([
  KW.TAUNT, KW.STEALTH, KW.PIERCE, KW.RUSH, KW.FRENZY,
  KW.SUPPRESSION, KW.INFECTED, KW.IMMUNE, KW.POSTHUMOUS_CONTRACT
]);

const WARNED = new Set();

export function hasKeyword(card, kw) {
  return Array.isArray(card?.keywords) && card.keywords.includes(kw);
}

// Снять ключевое слово с карты (мутирует card.keywords).
// Используется при разовом срабатывании эффекта (например, активация Скрытности).
// До А.4.2 (Молчание/баффы) храним keywords прямо на card — в будущем уйдёт в card.current.
export function removeKeyword(card, kw) {
  if (!Array.isArray(card?.keywords)) return false;
  const i = card.keywords.indexOf(kw);
  if (i < 0) return false;
  card.keywords.splice(i, 1);
  return true;
}

// Однократное предупреждение про неизвестные ключевые слова (например, "rush").
// Не падаем — просто пишем в console.warn один раз на ключевое слово.
export function warnIfUnknownKeywords(card) {
  if (!card?.keywords) return;
  for (const kw of card.keywords) {
    if (!KNOWN.has(kw) && !WARNED.has(kw)) {
      WARNED.add(kw);
      console.warn(`[keywords] Неизвестное ключевое слово "${kw}" — игнорируется (на А.4.1)`);
    }
  }
}
